import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, Link } from 'react-router-dom';

// Components //
import View from 'components/View';
import Dot from './Dot';

const Root = styled(View)`
  & > * + * {
    margin-top: 12px;
  }
`;

class Pagination extends Component {

  static propTypes = {
    items: PropTypes.array.isRequired
  };

  _renderDots = () => {
    const { completedSteps, items } = this.props;
    return items.map((item, index) => {
      const isComplete = completedSteps.includes(index);
      return (
        <Route
          key={item}
          path={item}
          exact
          children={({ match }) => {
            if (isComplete || match) {
              return (
                <Link to={item}>
                  <Dot active={true} />
                </Link>
              )
            } else {
              return (
                <Dot active={false} />
              )
            }
          }}
        />
      )
    })
  }

  render() {
    return (
      <Root>
        { this._renderDots() }
      </Root>
    );
  }
}

export default Pagination;
